import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import AboutHero from "@/pages/about/components/AboutHero";
import AboutIntroSection from "@/pages/about/components/AboutIntroSection";
import AboutCardsSection from "@/pages/about/components/AboutCardsSection";
import AboutOutroSection from "@/pages/about/components/AboutOutroSection";
import { Link } from "react-router-dom";

export default function AboutFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="À propos de nous | NetBasis International"
        description="Découvrez NetBasis International – votre expert sectoriel pour un soutien commercial stratégique et opérationnel depuis 2008."
        ogUrl="https://net-basis.net/fr/a-propos"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <AboutHero
          texts={{
            title_line1: "Nous faisons bouger ",
            title_line2: "les choses ...",
            subtitle: "... pour VOUS !",
          }}
        />

        <AboutIntroSection
          texts={{
            h1: "Votre partenaire expérimenté pour un succès commercial durable dans la région DACH. Sous le fil conducteur de « linking people & business », nous accompagnons les fabricants étrangers de TIC, de la planification stratégique à la réussite de l'exécution opérationnelle sur le terrain.",
            p1: "NetBasis International a été fondée à Düsseldorf au début de l'année 2008. Depuis lors, sous la devise « linking people & business », nous offrons aux fabricants étrangers du secteur des télécommunications et de l'informatique qui souhaitent étendre leurs activités commerciales sur les marchés de la région DACH ou intensifier leurs activités existantes, toutes les formes de conseil et d'assistance commerciale, ainsi qu'une aide experte dans le développement et l'adaptation de produits spécifiques au marché.",
            p2: "En collaboration avec nos fabricants partenaires, nous répondons à toutes les questions stratégiques et travaillons d'arrache-pied autour d'un objectif unique : votre réussite et l'obtention des meilleurs résultats commerciaux sur de nouveaux marchés !",
            p3: "Pour atteindre cet objectif, les entreprises étrangères bénéficient grâce à nous d'un accès immédiat à des connaissances sectorielles spécifiques, à une longue expérience du marché et à un vaste réseau de contacts. Elles évitent les barrières culturelles et linguistiques grâce à notre présence immédiate et profitent de notre travail opérationnel rapide sur les marchés, les produits, les partenaires et les clients.",
            strongName: "NetBasis International",
          }}
        />

        <AboutCardsSection
          texts={{
            management_title: "Direction",
            management_desc: "Plus de 30 ans d'expertise : profitez d'une profonde connaissance du marché et d'une longue expérience de direction internationale pour votre succès dans la région DACH.",
            core_values_title: "Valeurs fondamentales",
            core_values_desc: "Des valeurs fortes : portés par le respect, la loyauté et le professionnalisme, nous assurons votre succès – votre projet est entre de meilleures mains.",
            mission_vision_title: "Mission/Vision",
            mission_vision_desc: "L'humain fait la différence : la technologie seule ne suffit pas. En étroite collaboration, nous menons ensemble votre projet vers un résultat sûr.",
            read_more: "En savoir plus",
          }}
          urls={{
            management: "/fr/a-propos/direction",
            core_values: "/fr/a-propos/valeurs-fondamentales",
            mission_vision: "/fr/a-propos/mission-vision",
          }}
        />

        <AboutOutroSection
          texts={{
            strongName: "NetBasis International",
            p4: "Pour renforcer les relations existantes ainsi que pour acquérir de nouveaux clients et assurer ainsi un développement plus durable de nouveaux marchés, nous nous appuyons sur une approche de partenariat dans tous los domaines de la vente et du marketing. Cela comprend également le travail en commun sur des solutions matérielles et logicielles sophistiquées, parfaitement adaptées aux exigences actuelles du marché.",
            p5: "Tant notre philosophie d'entreprise que notre orientation éthique impliquent que NetBasis International se concentre stratégiquement sur un nombre limité de fabricants partenaires compétents qui ne se trouvent pas en concurrence directe au sein du secteur. Nous privilégions délibérément le développement conjoint et la coopération synergique au sein du groupe plutôt qu'une concurrence improductive.",
            p6: "Tout cela offre une sécurité maximale pour chaque nouveau partenaire et fait partie intégrante de l'ensemble des services que nous vous proposons lorsque vous décidez de vous engager dans une coopération fructueuse avec nous.",
          }}
        />

        {/* Contact CTA */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              Contactez-nous directement maintenant.
            </h2>
            <Link
              to="/fr/contact"
              className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-4 font-heading text-sm md:text-base font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Formulaire de contact
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}